/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronRight = createReactComponent("chevron-right", "IconChevronRight", [
  ["path", { d: "M9 6l6 6l-6 6", key: "svg-0" }]
]);

export { IconChevronRight as default };
//# sourceMappingURL=IconChevronRight.js.map
